module.exports = __webpack_public_path__ + "img/zorro-icon.d25163bd.png";